import * as React from "react";
import { makeStyles } from "@material-ui/core";
import { SvgIcon } from "@material-ui/core";

// styles
import { colors, greys } from "@styles/color.styles";

// util
// import { classNames } from "@util/html.util";

export interface CwIconProps {
  variant: "autopilot";
  color?: "Green" | "Peach" | "Grey";
  className?: string;
}

const useStyles = makeStyles({
  bold: {
    fontWeight: "bold",
  },
  icon: {
    padding: 4,
  },
});

const getSvgGibberish = (variant: string) => {
  if (variant === "autopilot") {
    return "M19 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h4l3 3 3-3h4c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-5.12 10.88L12 17l-1.88-4.12L6 11l4.12-1.88L12 5l1.88 4.12L18 11l-4.12 1.88z";
  }

  return "";
};

const getFillColor = (color: string) => {
  if (color === "Peach") {
    return colors.peach.darker;
  }

  if (color === "Grey") {
    return greys.cloudyBlue;
  }

  return colors.green.darker;
};

export const CwIcon = ({ variant, className, color = "Green" }: CwIconProps) => {
  const classes = useStyles();

  const iconGibberish = getSvgGibberish(variant);

  const fillColor = getFillColor(color);

  return (
    <SvgIcon className={classes.icon + " " + className || ""}>
      <path fill={fillColor} d={iconGibberish} />
    </SvgIcon>
  );
};
